// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-9f573824","scoped":true,"hasInlineConfig":false}!./src/components/nudge-console/CreateCampaign.css
// module id = rJGc
// module chunks = 1